import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";

import themeColorsDesingSystem from "assets/theme/ds-colors";
import { STATUS_SUCESSO, STATUS_PARCIAL } from "./importStatus";

export default function DialogDetalheImportacao({ open, item, onClose }) {
  if (!item) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle disableTypography>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography
            variant="h3"
            style={{
              color: themeColorsDesingSystem.primary.main,
              fontWeight: 700,
            }}
          >
            Detalhes da importação
          </Typography>
          <IconButton size="small" onClick={onClose} aria-label="Fechar">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <Box
          display="grid"
          gridTemplateColumns="repeat(auto-fit, minmax(180px, 1fr))"
          gridGap={16}
          mb={3}
        >
          <Box>
            <Typography variant="caption">Data</Typography>
            <Typography variant="body2">{item.dataAlteracao || "-"}</Typography>
          </Box>
          <Box>
            <Typography variant="caption">Usuário</Typography>
            <Typography variant="body2">{item.nome || "-"}</Typography>
          </Box>
          <Box>
            <Typography variant="caption">Id usuário</Typography>
            <Typography variant="body2">{item.idUsuario ?? "-"}</Typography>
          </Box>
          <Box>
            <Typography variant="caption">Status</Typography>
            <Typography
              variant="body2"
              style={{
                color:
                  item.statusProcesso === STATUS_SUCESSO
                    ? "#2e7d32"
                    : item.statusProcesso === STATUS_PARCIAL
                      ? "#ed6c02"
                      : "#d32f2f",
                fontWeight: 600,
              }}
            >
              {item.statusProcesso}
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="subtitle2"
          style={{ fontWeight: 600, marginBottom: 8 }}
        >
          Mensagem completa
        </Typography>
        <Box
          component="pre"
          style={{
            margin: 0,
            padding: 16,
            borderRadius: 8,
            backgroundColor: "#f5f7fa",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            fontFamily: "inherit",
            fontSize: 14,
            lineHeight: 1.5,
            maxHeight: 420,
            overflow: "auto",
          }}
        >
          {item.mensagem || "Nenhum detalhe registrado."}
        </Box>
      </DialogContent>

      <DialogActions style={{ padding: "12px 24px" }}>
        <Button onClick={onClose} color="primary" variant="contained">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
